import React from 'react'
import FlexboxChallenge from './FlexboxChallenge'

export default class extends React.Component {
  render() {
    const literalStyles = `
      .no-cheating, .flexbox-challenge {
        height: 500px;
      }

      .no-cheating > *, .flexbox-challenge > *{
        margin: 10px;
        flex-basis: 45%;
      }

      .no-cheating {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .flexbox-challenge {
        display: flex;
        flex-wrap: GRRRRRAAAAATTTT;
        justify-content: MMMRRRRUUUUGGGGGG;
      }
    `

    return (
      <FlexboxChallenge
        title="Flexbox Devtools Challenge"
        description="Fix the Flexbox layout using just the devtools!"
        literalStyles={literalStyles}
        nextChallenge={10}
      >
        <div />
        <div />
        <div />
      </FlexboxChallenge>
    )
  }
}
